
const ESchemaObject = Object.freeze([
    // Column #1
    {
        column: 'Kode Kegiatan',
        type: String,
        value: item => item.kode1
    },
    // Column #3
    {
        column: 'Nama Kegiatan',
        type: String,
        width:70,
        value: item => item.description
    },
    // Column #4
    {
        column: 'Kode-Sub',
        type: String,
        value: item => item.kode2
    },

    {
        column: 'Tahun',
        type: Number,
        value: item => item.tahun
    },
    // Column #7
    {
        column: 'Nama Pekerjaan',
        type: String,
        width:70,
        value: item => item.namaPekerjaan
    },
    // Column #8
    {
        column: 'Ganti Nama Paket',
        type: String,
        value: item => item.gantiNamaPaket
    },
    // Column #9
    {
        column: 'Nilai Pagu',
        type: Number,
        format: '#,##0.00',
        value: item => item.nilaiPagu
    },
    // Column #10
    {
        column: 'Latitude',
        type: Number,
        format: '#,##0.000000',
        value: item => item.lat
    },
    // Column #11
    {
        column: 'Longitude',
        type: Number,
        format: '#,##0.000000',
        value: item => item.lon
    },
    // Column #12
    {
        column: 'Nomor Kontrak',
        type: String,
        value: item => item.nomorKontrak
    },
    // Column #13
    {
        column: 'Tanggal Kontrak',
        type: Date,
        format: 'dd-MMM-yyyy',
        value: item => new Date(item.tglKontrak)
    },
    // Column #14
    {
        column: 'Nilai Kontrak',
        type: Number,
        format: '#,##0.00',
        value: item => item.nilaiKontrak
    },
    // Column #15
    {
        column: 'Adendum',
        type: String,
        value: item => item.nomorAdendum
    },
    // Column #16
    {
        column: 'Tanggal Adendum',
        type: Date,
        format: 'dd-MMM-yyyy',
        value: item => new Date(item.tglAdendum)
    },
    // Column #17
    {
        column: 'Kemajuan Fisik',
        type: Number,
        value: item => item.persenKemajuan
    },
    // Column #18
    {
        column: 'Termin1',
        type: Number,
        format: '#,##0.00',
        value: item => item.termin1Cair
    },
    // Column #19
    {
        column: 'Termin2',
        type: Number,
        format: '#,##0.00',
        value: item => item.termin2Cair
    },


])


export default ESchemaObject